/* eslint-disable array-callback-return */
import React, { useState, useRef, useContext, useEffect } from "react"
import { Fieldset } from "primereact/fieldset"
import PropTypes from "prop-types"
import { Toast } from "primereact/toast"
import { Toolbar } from "primereact/toolbar"
import CustomToolBar from "../../../ToolBar/customToolbar"
import { errorMessages } from "../../../types/messages"
import {
  existsErrors,
  getAdditionalQuestions,
  showMessage,
  showQuestion,
  updateState,
  validateQuestions,
  formatMixedQuestions,
  filterAdditionalQuestions,
  checkDisplayConditional,
  checkConditionalRender,
  prevForm,
  nextForm,
} from "../../../utils/utils"
import ServicesRow from "../../B/PlannedServices/ServicesRow"
import { GpraContext } from "../../../../../context/gpraContext"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import FormLabel from "../../../Common/FormLabel"
import FormError from "../../../Common/FormError"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import { INTERVIEW_SECTIONS } from "../../../types/interviewTypes"
import { InputText } from "primereact/inputtext"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"
import { UserContext } from "../../../../../context/userContext"

const ServicesReceived2 = (props) => {
  const { showToolBar, disabled } = props
  const {
    handleSubmitPut,
    interview,
    handleLoadPrev,
    handleLoadNext,
    handleSectionsCompleted,
    sectionsCompleted,
    questions,
    updateInterviewValues,
    additionalQuestions,
    sections,
    activeIndex,
    administrativeInterview,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [servicesReceived2, setServicesReceived2] = useState(
    interview[INTERVIEW_SECTIONS.SERVICES_RECEIVED_2]
  )
  const [validationErrors, setValidationErrors] = useState({})
  const [mixedQuestions, setMixedQuestions] = useState([])

  const toast = useRef(null)

  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions.filter(
          (q) => q.section === INTERVIEW_SECTIONS.SERVICES_RECEIVED_2
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.SERVICES_RECEIVED_2
        )
      }
      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])

  const saveData = (setNextForm, previousForm, setNavigationItem) => {
    updateInterviewValues(
      INTERVIEW_SECTIONS.SERVICES_RECEIVED_2,
      servicesReceived2
    )
    if (previousForm) {
      handleLoadPrev(true)
      setNextForm(prevForm(sections, activeIndex, administrativeInterview))
      setNavigationItem()
    } else {
      if (validForm()) {
        handleLoadNext(true)
        handleSubmitPut(endpoints.SAVE_SERVICESRECEIVED2_DATA, {
          GpraKTs1: servicesReceived2?.gpra_k_ts_1,
          GpraKTs2: servicesReceived2?.gpra_k_ts_2,
          GpraKTs3: servicesReceived2?.gpra_k_ts_3,
          GpraKTs4: servicesReceived2?.gpra_k_ts_4,
          GpraKTs5: servicesReceived2?.gpra_k_ts_5,
          GpraKTs6: servicesReceived2?.gpra_k_ts_6,
          GpraKTs7: servicesReceived2?.gpra_k_ts_7,
          GpraKTs8: servicesReceived2?.gpra_k_ts_8,
          GpraKTs9: servicesReceived2?.gpra_k_ts_9,
          GpraKTs10: servicesReceived2?.gpra_k_ts_10,
          GpraKTs11: servicesReceived2?.gpra_k_ts_11,
          GpraKTs12: servicesReceived2?.gpra_k_ts_12,
          GpraKTs13: servicesReceived2?.gpra_k_ts_13,
          GpraKTs14: servicesReceived2?.gpra_k_ts_14,
          GpraKTs15: servicesReceived2?.gpra_k_ts_15,
          GpraKTs16: servicesReceived2?.gpra_k_ts_16,
          GpraKTs17: servicesReceived2?.gpra_k_ts_17,
          GpraKTs18: servicesReceived2?.gpra_k_ts_18,
          GpraKTs18a: servicesReceived2?.gpra_k_ts_18a,
          GpraInterviewId:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          GpraKId: servicesReceived2?.gpra_k_id,
          Additional: getAdditionalQuestions(servicesReceived2),
          EditMode: editMode,
          EditedBy: userCtx.session?.user?.staff_id,
        })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              handleLoadNext(false)
              setNextForm(
                nextForm(sections, activeIndex, administrativeInterview)
              )
              setNavigationItem()
              handleSectionsCompleted({
                ...sectionsCompleted,
                ...{ servicesReceived2: true },
              })
            }
          })
          .catch(() => {
            handleLoadNext(false)
            showMessage(false, errorMessages.genericError, toast)
          })
      } else {
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }

  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }

  const validForm = () => {
    const errors = {}
    if (
      servicesReceived2?.gpra_k_ts_18 > 0 &&
      !servicesReceived2?.gpra_k_ts_18a &&
      showQuestion(questions, "gpra_k_ts_18")
    ) {
      errors.gpra_k_ts_18a = errorMessages.requiredMessage
    }
    setValidationErrors(
      validateQuestions(
        servicesReceived2,
        INTERVIEW_SECTIONS.SERVICES_RECEIVED_2,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }

  const renderDefaultMain = (question) => {
    if (question.field === "gpra_k_ts_1") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={
                "Identify the number of DAYS of services provided to the client during the client’s course of treatment/recovery."
              }
            />
          </div>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={
                "[SBIRT GRANTS: You must have at least one session for one of the Treatment Services numbered 1 through 4.]"
              }
            />
          </div>
          <div className={gpraStyles.formRow}>
            <FormLabel label={`${question.number}. Treatment Services`} />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived2}
              setEntity={setServicesReceived2}
              showDrop={false}
              removeError={removeError}
              label={`1. Screening`}
              number={servicesReceived2?.gpra_k_ts_1}
              setNumber={"gpra_k_ts_1"}
              numberError={validationErrors.gpra_k_ts_1}
              numberErrorType={"gpra_k_ts_1"}
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived2}
              setEntity={setServicesReceived2}
              showDrop={false}
              removeError={removeError}
              label={`2. Brief Intervention`}
              number={servicesReceived2?.gpra_k_ts_2}
              setNumber={"gpra_k_ts_2"}
              numberError={validationErrors.gpra_k_ts_2}
              numberErrorType={"gpra_k_ts_2"}
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived2}
              setEntity={setServicesReceived2}
              showDrop={false}
              removeError={removeError}
              label={`3. Brief Treatment`}
              number={servicesReceived2?.gpra_k_ts_3}
              setNumber={"gpra_k_ts_3"}
              numberError={validationErrors.gpra_k_ts_3}
              numberErrorType={"gpra_k_ts_3"}
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived2}
              setEntity={setServicesReceived2}
              showDrop={false}
              removeError={removeError}
              label={`4. Referral to Treatment`}
              number={servicesReceived2?.gpra_k_ts_4}
              setNumber={"gpra_k_ts_4"}
              numberError={validationErrors.gpra_k_ts_4}
              numberErrorType={"gpra_k_ts_4"}
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived2}
              setEntity={setServicesReceived2}
              showDrop={false}
              removeError={removeError}
              label={`5. Assessment`}
              number={servicesReceived2?.gpra_k_ts_5}
              setNumber={"gpra_k_ts_5"}
              numberError={validationErrors.gpra_k_ts_5}
              numberErrorType={"gpra_k_ts_5"}
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived2}
              setEntity={setServicesReceived2}
              showDrop={false}
              removeError={removeError}
              label={`6. Treatment Planning`}
              number={servicesReceived2?.gpra_k_ts_6}
              setNumber={"gpra_k_ts_6"}
              numberError={validationErrors.gpra_k_ts_6}
              numberErrorType={"gpra_k_ts_6"}
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived2}
              setEntity={setServicesReceived2}
              showDrop={false}
              removeError={removeError}
              label={`7. Recovery Planning`}
              number={servicesReceived2?.gpra_k_ts_7}
              setNumber={"gpra_k_ts_7"}
              numberError={validationErrors.gpra_k_ts_7}
              numberErrorType={"gpra_k_ts_7"}
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived2}
              setEntity={setServicesReceived2}
              showDrop={false}
              removeError={removeError}
              label={`8. Individual Counseling`}
              number={servicesReceived2?.gpra_k_ts_8}
              setNumber={"gpra_k_ts_8"}
              numberError={validationErrors.gpra_k_ts_8}
              numberErrorType={"gpra_k_ts_8"}
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived2}
              setEntity={setServicesReceived2}
              showDrop={false}
              removeError={removeError}
              label={`9. Group Counseling`}
              number={servicesReceived2?.gpra_k_ts_9}
              setNumber={"gpra_k_ts_9"}
              numberError={validationErrors.gpra_k_ts_9}
              numberErrorType={"gpra_k_ts_9"}
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived2}
              setEntity={setServicesReceived2}
              showDrop={false}
              removeError={removeError}
              label={`10. Contingency Management`}
              number={servicesReceived2?.gpra_k_ts_10}
              setNumber={"gpra_k_ts_10"}
              numberError={validationErrors.gpra_k_ts_10}
              numberErrorType={"gpra_k_ts_10"}
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived2}
              setEntity={setServicesReceived2}
              showDrop={false}
              removeError={removeError}
              label={`11. Community Reinforcement`}
              number={servicesReceived2?.gpra_k_ts_11}
              setNumber={"gpra_k_ts_11"}
              numberError={validationErrors.gpra_k_ts_11}
              numberErrorType={"gpra_k_ts_11"}
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived2}
              setEntity={setServicesReceived2}
              showDrop={false}
              removeError={removeError}
              label={`12. Cognitive Behavioral Therapy`}
              number={servicesReceived2?.gpra_k_ts_12}
              setNumber={"gpra_k_ts_12"}
              numberError={validationErrors.gpra_k_ts_12}
              numberErrorType={"gpra_k_ts_12"}
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived2}
              setEntity={setServicesReceived2}
              showDrop={false}
              removeError={removeError}
              label={`13. Family/Marriage Counseling`}
              number={servicesReceived2?.gpra_k_ts_13}
              setNumber={"gpra_k_ts_13"}
              numberError={validationErrors.gpra_k_ts_13}
              numberErrorType={"gpra_k_ts_13"}
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived2}
              setEntity={setServicesReceived2}
              showDrop={false}
              removeError={removeError}
              label={`14. Co-Occurring Treatment Services`}
              number={servicesReceived2?.gpra_k_ts_14}
              setNumber={"gpra_k_ts_14"}
              numberError={validationErrors.gpra_k_ts_14}
              numberErrorType={"gpra_k_ts_14"}
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived2}
              setEntity={setServicesReceived2}
              showDrop={false}
              removeError={removeError}
              label={`15. Pharmacological Interventions`}
              number={servicesReceived2?.gpra_k_ts_15}
              setNumber={"gpra_k_ts_15"}
              numberError={validationErrors.gpra_k_ts_15}
              numberErrorType={"gpra_k_ts_15"}
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived2}
              setEntity={setServicesReceived2}
              showDrop={false}
              removeError={removeError}
              label={`16. HIV/AIDS Counseling`}
              number={servicesReceived2?.gpra_k_ts_16}
              setNumber={"gpra_k_ts_16"}
              numberError={validationErrors.gpra_k_ts_16}
              numberErrorType={"gpra_k_ts_16"}
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived2}
              setEntity={setServicesReceived2}
              showDrop={false}
              removeError={removeError}
              label={`17. Cultural Interventions/Activities`}
              number={servicesReceived2?.gpra_k_ts_17}
              setNumber={"gpra_k_ts_17"}
              numberError={validationErrors.gpra_k_ts_17}
              numberErrorType={"gpra_k_ts_17"}
              summaryDisabled={disabled}
              defaultZero={question.defaultZero}
            />
          </div>
          <div className={gpraStyles.formRow}>
            <ServicesRow
              entity={servicesReceived2}
              setEntity={setServicesReceived2}
              showDrop={false}
              removeError={removeError}
              label={`18. Other Clinical Services (Specify)`}
              number={servicesReceived2?.gpra_k_ts_18}
              setNumber={"gpra_k_ts_18"}
              numberError={validationErrors.gpra_k_ts_18}
              numberErrorType={"gpra_k_ts_18"}
              summaryDisabled={disabled}
              extraValues={[{ key: "gpra_k_ts_18a", value: "" }]}
              defaultZero={question.defaultZero}
            />
          </div>
          {servicesReceived2?.gpra_k_ts_18 > 0 && (
            <div className={gpraStyles.formRow}>
              <InputText
                className={
                  validationErrors.gpra_k_mod_11a
                    ? gpraStyles.inputText5Error
                    : gpraStyles.inputText5
                }
                disabled={disabled}
                placeholder={
                  !servicesReceived2?.gpra_k_ts_18 ? "Not Applicable" : ""
                }
                value={servicesReceived2?.gpra_k_ts_18a}
                onChange={(e) => {
                  updateState(
                    "gpra_k_ts_18a",
                    e.target.value,
                    null,
                    null,
                    servicesReceived2,
                    setServicesReceived2,
                    null
                  )
                  removeError("gpra_k_ts_18a")
                }}
              />
              <FormError error={validationErrors.gpra_k_ts_18a} />
            </div>
          )}
        </>
      )
    }
  }
  
  return (
    <div>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mb2}
          right={
            <CustomToolBar
              toast={toast}
              prevForm={true}
              saveData={saveData}
              nextForm={true}
            />
          }
        ></Toolbar>
      )}
      <Fieldset
        legend="K. SERVICES RECEIVED UNDER GRANT FUNDING"
        style={{ marginBottom: "1rem" }}
      >
        <div className={gpraStyles.grid}>
          {mixedQuestions?.map((question) => {
            if (question.kind === "default") {
              if (question.show) {
                return renderDefaultMain(question)
              }
            } else {
              if (
                checkConditionalRender(
                  question.enabled,
                  question.required,
                  question.kind,
                  question.conditionalSource
                )
              ) {
                return (
                  <AdditionalQuestionContainer
                    entity={servicesReceived2}
                    setEntity={setServicesReceived2}
                    errors={validationErrors}
                    section={INTERVIEW_SECTIONS.SERVICES_RECEIVED_2}
                    removeError={removeError}
                    disabled={disabled}
                    question={question.question}
                    number={question.number}
                    kind={question.kind}
                  />
                )
              } else {
                if (checkDisplayConditional(question, servicesReceived2)) {
                  return (
                    <AdditionalQuestionContainer
                      entity={servicesReceived2}
                      setEntity={setServicesReceived2}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.SERVICES_RECEIVED_2}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  )
                }
              }
            }
          })}
        </div>
      </Fieldset>
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mt2}
          right={
            <CustomToolBar
              toast={toast}
              prevForm={true}
              saveData={saveData}
              nextForm={true}
            />
          }
        ></Toolbar>
      )}
    </div>
  )
}

ServicesReceived2.propTypes = {
  showToolBar: PropTypes.bool,
  disabled: PropTypes.bool,
}

ServicesReceived2.defaultProps = {
  showToolBar: true,
  disabled: false,
}

export default ServicesReceived2
